import { render, staticRenderFns } from "./ANZBUTTONRIGHT.vue?vue&type=template&id=4345bf5f"
import script from "./ANZBUTTONRIGHT.vue?vue&type=script&lang=js"
export * from "./ANZBUTTONRIGHT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports